/* tslint:disable */
/* eslint-disable */
import { exists } from '../runtime';

/**
 * A friendly tariff-picker chip (e.g. "Shoes"). `chapters` holds 2-digit HS
 * chapters and/or 4-digit headings.
 */
export interface TariffCategory {
    id?: number;
    name: string;
    /** Lucide icon name. */
    icon?: string;
    chapters: string[];
    displayOrder?: number;
    isActive?: boolean;
    createdAt?: Date;
    updatedAt?: Date;
}

export function TariffCategoryFromJSON(json: any): TariffCategory {
    return TariffCategoryFromJSONTyped(json, false);
}

export function TariffCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TariffCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
        'chapters': json['chapters'] == null ? [] : json['chapters'],
        'displayOrder': !exists(json, 'displayOrder') ? undefined : json['displayOrder'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'createdAt': !exists(json, 'createdAt') ? undefined : new Date(json['createdAt']),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : new Date(json['updatedAt']),
    };
}

export function TariffCategoryToJSON(value?: Partial<TariffCategory> | null): any {
    return TariffCategoryToJSONTyped(value, false);
}

export function TariffCategoryToJSONTyped(value?: Partial<TariffCategory> | null, ignoreDiscriminator: boolean = false): any {
    if (value === undefined) { return undefined; }
    if (value === null) { return null; }
    return {
        'name': value.name,
        'icon': value.icon,
        'chapters': value.chapters,
        'displayOrder': value.displayOrder,
        'isActive': value.isActive,
    };
}
